/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetForecastAggregatedBudgetReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The SheetForecastAggregatedBudgetReport model module.
   * @module model/SheetForecastAggregatedBudgetReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetForecastAggregatedBudgetReport</code>.
   * @alias module:model/SheetForecastAggregatedBudgetReport
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>SheetForecastAggregatedBudgetReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetForecastAggregatedBudgetReport} obj Optional instance to populate.
   * @return {module:model/SheetForecastAggregatedBudgetReport} The populated <code>SheetForecastAggregatedBudgetReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SelectedYear')) {
        obj['SelectedYear'] = ApiClient.convertToType(data['SelectedYear'], 'Integer');
      }
      if (data.hasOwnProperty('SelectedMonth')) {
        obj['SelectedMonth'] = ApiClient.convertToType(data['SelectedMonth'], 'Integer');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('AggregatedBudgetTotal')) {
        obj['AggregatedBudgetTotal'] = ApiClient.convertToType(data['AggregatedBudgetTotal'], 'Number');
      }
      if (data.hasOwnProperty('CurrentTotal')) {
        obj['CurrentTotal'] = ApiClient.convertToType(data['CurrentTotal'], 'Number');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} SelectedYear
   * @default 0
   */
  exports.prototype['SelectedYear'] = 0;
  /**
   * @member {Integer} SelectedMonth
   * @default 0
   */
  exports.prototype['SelectedMonth'] = 0;
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {Number} AggregatedBudgetTotal
   * @default 0.0
   */
  exports.prototype['AggregatedBudgetTotal'] = 0.0;
  /**
   * @member {Number} CurrentTotal
   * @default 0.0
   */
  exports.prototype['CurrentTotal'] = 0.0;



  return exports;
}));


